<template>
  <navigation-layout
    :footerEntries="navigationFooter">
    <centered-form-layout
      @submit.prevent="submit"
      :title="$t('auth.login')">
      <form-message
        class="mt-4"
        v-if="error">
        {{ $t('auth.authenticate_error_message') }}
      </form-message>
      <form-row class="mt-4">
        <form-input
          :required="true"
          v-model="username">
          {{ $t('generic.username') }}
        </form-input>
      </form-row>
      <form-row class="mt-4">
        <form-input
          type="password"
          :required="true"
          v-model="password">
          {{ $t('generic.password') }}
        </form-input>
      </form-row>
      <form-row>
        <c-button
          class="mt-4"
          type="submit"
          :disabled="loading">
          {{ $t('auth.login') }}
        </c-button>
        <c-button
          class="mt-2"
          type="button"
          :disabled="loading"
          @click.prevent="loginAsGuest">
          {{ $t('auth.login_as_guest') }}
        </c-button>
      </form-row>
      <form-row class="mt-4">
        <div class="flex justify-between">
          <router-link
            v-if="showRegisterLink"
            :to="resolve(registerLink)"
            class="text-sm hover:underline">
            {{ $t('auth.register') }}
          </router-link>
          <router-link
            :to="resolve(forgotLink)"
            class="text-sm hover:underline">
            {{ $t('auth.forgot') }}
          </router-link>
        </div>
      </form-row>
      <form-row class="mt-4">
        <div
          v-html="customLoginText"
          class="flex justify-between"
        />
      </form-row>
    </centered-form-layout>
  </navigation-layout>
</template>

<script>
  import DesignMixin from '../../mixin/design'
  import {mapGetters} from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        logo: 'app/logo',
        customText: 'config/customText',
        saveUrl: 'auth/saveUrl'
      }),
      registerLink() {
        return this.$route.params.slug
          ? '/' + this.$route.params.slug + '/auth/register'
          : '/auth/register'
      },
      forgotLink() {
        return this.$route.params.slug
          ? '/' + this.$route.params.slug + '/auth/forgot'
          : '/auth/forgot'
      },
      customLoginText() {
        return this.findCustomText('login')
      }
    },
    data() {
      return {
        error: false,
        password: null,
        username: null,
        loading: false,
        category: null,
        navigationFooter: [],
        showRegisterLink: false,
      }
    },
    /**
     * Load client root category and apply design (colors/images).
     * If the a project url has been called the design of it will be used.
     * @return {Promise<void>}
     */
    async created() {
      // Apply Design && Check if register link should be shown
      this.category = await this.applyDesign()
      if (this.category) {
        let cmsConfiguration = this.$helper.findAttributeValue(this.category, 'CMS-Configuration')
        if (cmsConfiguration) {
          this.showRegisterLink = cmsConfiguration.includes('EnableRegister')
        }
      }
      this.navigationFooter = await this.$helper.buildFooter(this.$api, this.category)
      this.$emit('updateUI')

      // Reset credentials if not happened yet
      this.$store.commit('auth/setUser', null)
      this.$store.commit('auth/setAuthCode', null)
    },
    methods: {
      /**
       * Authenticates as a guest
       */
      loginAsGuest() {
        return this.$router.back()
      },
      /**
       * Authenticates with given credentials
       * @return {Promise<void>}
       */
      async submit() {
        this.error = false
        this.loading = true
        let authResponse = await this.$api.login(this.username, this.password)
        authResponse = await authResponse.json()
        if (authResponse && !authResponse.error) {
          this.$store.commit('auth/setUser', authResponse)
          this.$store.commit('auth/setUserAttributes', authResponse.attributes)
          this.$store.commit('auth/setAuthCode', btoa(`${this.username}:${this.password}`))
          let categoryId = this.$route.params.slug
          if (authResponse.startId && authResponse.startId.length > 0) {
              categoryId = 'startfirst-' + categoryId + '/startit-' + authResponse.startId
          } else {
            if (this.saveUrl)  {
              categoryId = this.saveUrl
              if (categoryId.startsWith("/"))
                categoryId = categoryId.substr(1)
            }
          }
          return categoryId
            ? await this.go('/' + categoryId)
            : await this.go('/')
        }
        this.loading = false
        this.error = true
      },
    },
    inject: [
      '$api',
      '$helper'
    ],
    mixins: [
      DesignMixin
    ]
  }
</script>

<style lang="scss" scoped>
  button.mt-4 {
    background: var(--tertiary);
    color: white;
    &:hover {
      color: white;
      background: var(--secondary);
      transition: .2s all;
    }
  }
</style>